import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";
const initialState = {
  data: [],
  state: ""
};
export const componentsSlice = createSlice({
  name: "components",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getComponents.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getComponents.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getComponents = createAsyncThunk('sprints/get', async({ query, workspaceId }) => {
  let data = await DevelopmentAPI.getComponents(query, workspaceId);
  return data['components'];

});


export default componentsSlice.reducer;